import styled from 'styled-components';

export const BlurLoaderBlurry = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const BlurLoader = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;
